import { Shark, View } from "shark-mvc";

import templateContent from "./dev-tools.html";

import mainNavComponent from "../../components/mainNav/mainNavComponent";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import imageContentManager from "../../controllers/imageContentManager";
import placeContentManager from "../../controllers/placeContentManager";
import textContentManager from "../../controllers/textContentManager";
import ImageContent from "../../models/ImageContent";
import PlaceContent from "../../models/PlaceContent";
import TextContent from "../../models/TextContent";
import ContentRelation from "../../models/ContentRelation";
import contentRelationManager from "../../controllers/contentRelationManager";
import allContentListView from "../allContentList/allContentListView";

class DevToolsView extends View {
	recentRange = {
		first: 0,
		length: 5000,
	};

	recentSort = {
		updated_at: "ASC",
	};

	constructor () {
		super("devToolsView");
		this.setTemplate(templateContent);
	}

	afterLoad () {
	}
	
	beforeLoad () {	
	}

	init () {
		this.addComponents([mainNavComponent, waitBoxComponent]);

		Shark.set({
			allImageContentForRelationsList: [],
			allPlaceContentForRelationsList: [],
			allTextContentForRelationsList: [],
		});
	}
	
	async processRelatedContents () {
		await this.refreshList();

		const { allImageContentForRelationsList, allPlaceContentForRelationsList, allTextContentForRelationsList } = Shark.get();

		for (let item of allImageContentForRelationsList) {
			const relatedContentBatch = item.relatedContents.map(relatedContent => {
				return new ContentRelation({
					bidirectional: false,
					content1Guid: item.guid,
					content1Type: "image",
					content2Guid: relatedContent.guid,
					content2Type: relatedContent.type,
					extraData: {
						content1Title: item.title,
						content2Title: relatedContent.title,
					},
					status: 1,
				});
			});

			await contentRelationManager.insertMulti(relatedContentBatch);
			await allContentListView.sleep(40);
		}

		for (let item of allTextContentForRelationsList) {
			const relatedContentBatch = item.relatedContents.map(relatedContent => {
				return new ContentRelation({
					bidirectional: ["text"].includes(relatedContent.type),
					content1Guid: item.guid,
					content1Type: "text",
					content2Guid: relatedContent.guid,
					content2Type: relatedContent.type,
					extraData: {
						content1Title: item.title,
						content2Title: relatedContent.title,
					},
					status: 1,
				});
			});

			await contentRelationManager.insertMulti(relatedContentBatch);
			await allContentListView.sleep(40);
		}

		for (let item of allPlaceContentForRelationsList) {
			const relatedContentBatch = item.relatedContents.map(relatedContent => {
				return new ContentRelation({
					bidirectional: false,
					content1Guid: item.guid,
					content1Type: "place",
					content2Guid: relatedContent.guid,
					content2Type: relatedContent.type,
					extraData: {
						content1Title: item.title,
						content2Title: relatedContent.title,
					},
					status: 1,
				});
			});

			await contentRelationManager.insertMulti(relatedContentBatch);
			await allContentListView.sleep(40);
		}
	}

	processRelatedContentsBtn_clickHandler () {
		this.processRelatedContents();
	}

	async refreshList () {
		waitBoxComponent.open();

		await this.refreshImageContentList();
		await this.refreshPlaceContentList();
		await this.refreshTextContentList();

		waitBoxComponent.close();
	}

	async refreshImageContentList () {
		return imageContentManager.getRichList({ options: { includeTags: true}, range: this.recentRange, sort: this.recentSort })
		.then(response => {
			const imageContentList = Shark.getInstanceList(ImageContent, response.data);

			Shark.set({
				allImageContentForRelationsList: imageContentList,
			});

			return true;
		});
	}

	async refreshPlaceContentList () {
		return placeContentManager.getList({ options: { includeTags: true}, range: this.recentRange, sort: this.recentSort })
		.then(response => {
			const placeContentList = Shark.getInstanceList(PlaceContent, response.data);

			Shark.set({
				allPlaceContentForRelationsList: placeContentList,
			});

			return true;
		});
	}

	async refreshTextContentList () {
		return textContentManager.getRichList({ options: { includeTags: true}, range: this.recentRange, sort: this.recentSort })
		.then(response => {
			const textContentList = Shark.getInstanceList(TextContent, response.data);

			Shark.set({
				allTextContentForRelationsList: textContentList,
			});

			return true;
		});
	}

}

const devToolsView = new DevToolsView();

Shark.registerView(devToolsView);

export default devToolsView;